/**
 * Decode the `exp` (expiration) claim from a JWT.
 * Returns a Unix timestamp in seconds, or 0 on any error.
 *
 * No library — pure base64url decode. Used to decide when to
 * proactively refresh the access token.
 */
export function decodeJwtExp(token) {
  if (!token) return 0;
  try {
    const payload = token.split('.')[1];
    const decoded = JSON.parse(
      atob(payload.replace(/-/g, '+').replace(/_/g, '/'))
    );
    return decoded.exp || 0;
  } catch {
    return 0;
  }
}

/**
 * Return true if the token is expired or will expire within `skewSeconds`.
 */
export function isTokenNearExpiry(token, skewSeconds = 60) {
  const exp = decodeJwtExp(token);
  if (!exp) return true;
  const now = Math.floor(Date.now() / 1000);
  return exp - now < skewSeconds;
}